"use client";

import { useEditMode } from "@/contexts/EditModeContext";
import { cn } from "@/lib/shared/utils";
import { type ReactNode } from "react";

export default function FooterEditWrapper({ children }: { children: ReactNode }) {
  const { isEditing, isSectionHidden, openSectionEditor } = useEditMode();
  const hidden = isSectionHidden("footer");

  if (!isEditing) {
    if (hidden) return null;
    return <>{children}</>;
  }

  return (
    <div
      className={cn(
        "group/section outline-background/30 relative outline-2 outline-offset-4 outline-dashed",
        hidden && "opacity-30"
      )}
    >
      <div className="absolute -top-3 left-2 z-50">
        <button
          onClick={() => openSectionEditor("footer")}
          className="bg-background text-foreground hover:bg-background/80 cursor-pointer px-2 py-0.5 font-mono text-[9px] font-bold tracking-wider uppercase transition-colors"
          title="Edit footer"
        >
          footer
        </button>
      </div>
      {children}
    </div>
  );
}
